import { $GQL } from "@GQL/index";

export async function matchingArchivedLeadEmails(email: string) {
    const query = `
        query GetMatchingArchivedLeadEmails($email: String!) {
            matchingArchivedLeadEmails(email: $email)
        }`;

    const result = await $GQL.request(query, { email });
    return result;
}